<template>
  <div class="branded-fare-upsell__table__scrollable">
    <table class="table table-responsive-md">
      <thead>
        <tr class="table--sticky-row sticky-top">
          <td>Tariffa</td>
          <td
            v-for="(item, index) in flight_offers_upsell"
            :key="`head:${_uid}:${item.id}:${index}`"
            :class="
              item.id == selected_flight_offer_id ? 'selected' : ''
            "
          >
            {{ get_branded_fare(item) | capitalize }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(amenity, a_index) in table_amenities"
          :key="`amenities:${_uid}:${a_index}-all`"
        >
          <td>
            <branded-fare-amenity
              class="branded-fare-upsell__amenity"
              :item="get_amenity_info(amenity)"
            />
          </td>
          <td
            v-for="(item, f_index) in flight_offers_upsell"
            :key="`body:${_uid}:${item.id}:${f_index}`"
            :class="
              item.id == selected_flight_offer_id ? 'selected' : ''
            "
          >
            <vb-icon
              :class="`d-flex align-items-center justify-content-center table--amenity--${
                is_amenity_present(item.id, amenity.code) ? 'ok' : 'ko'
              }`"
              :name="'check_circle'"
              :size="18"
            ></vb-icon>
          </td>
        </tr>
        <tr class="table--sticky-row">
          <td></td>
          <td
            v-for="(item, f_index) in flight_offers_upsell"
            :key="`action:${_uid}:${item.id}:${f_index}`"
            :class="
              item.id == selected_flight_offer_id ? 'selected' : ''
            "
          >
            <div class="branded-fare-upsell__price">
              {{ apply_markup_to_number(item, item.price.grandTotal) }}
              {{ item.price.currencySymbol }}
            </div>
            <div class="branded-fare-upsell__actions">
              <div>
                <!--flexbox-->
                <vb-button
                  :vb_options="{
                    variant:
                      item.id === selected_flight_offer_id
                        ? 'outline-info'
                        : 'info',
                    block: true,
                    disabled:
                      item.id === selected_flight_offer_id &&
                      item.id === flight_offer_default.id,
                    text: get_fare_button_text(item),
                  }"
                  @click="() => on_select_flight_offer(item)"
                >
                </vb-button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { get_branded_fare } from "@liveflight/providers";
import { apply_markup_to_number } from "@liveflight/utilities/price";
import { get_amenity_info } from "@liveflight/resources";
import {
  is_amenity_present as _is_amenity_present,
  get_fare_button_text as _get_fare_button_text,
} from "./logic";
import BrandedFareAmenity from "./amenity.vue";

export default {
  name: "branded-fare-upsell-table",
  components: {
    "branded-fare-amenity": BrandedFareAmenity,
  },
  props: {
    flight_offers_upsell: { type: Array, default: () => [] },
    selected_flight_offer_id: [String, Number],
    table_amenities: { type: Array, default: () => [] },
    offers_amenities: { type: Object, default: () => ({}) },
    flight_offer_default: Object,
  },
  methods: {
    get_branded_fare,
    get_amenity_info,
    apply_markup_to_number,
    is_amenity_present(offer_id, amenity_code) {
      return _is_amenity_present(
        this.offers_amenities,
        offer_id,
        amenity_code,
      );
    },
    get_fare_button_text(item) {
      return _get_fare_button_text(
        item,
        this.selected_flight_offer_id,
        this.flight_offer_default,
      );
    },
    on_select_flight_offer(item) {
      this.$emit("select-flight-offer", item);
    },
  },
};
</script>
